import _ from "lodash"
import { ulid } from "ulid"
import { createDefultTriggerActionGroup, ITriggerActionGroup, mergeTriggerActionGroupToDefultData } from "../trigger-action/ITriggerActionGroup"
import { ExtractedObjectTypeValues } from "@fanfanlo"
export interface IProjectJavaData {
}

export interface IProjectShellData{
    id:string
}
export interface IProjectData{
    id:string
    type:string
    originId?:string
    name?:string
    localName?:string
    triggerActionGroup:ITriggerActionGroup  
}

// interface IP{
//     name?:string
//     triggerActionGroup:ITriggerActionGroup  
// }

// type A = ExtractedObjectTypeValues<IP>
// let a:A = 'a'

export function createProjectDefultData():IProjectData{
    // console.trace('ppppppppproject createProjectDefultData')
    return {
        type:'project',
        id:ulid(),
        triggerActionGroup:createDefultTriggerActionGroup()
    }

}

export function mergeProjectDataToDefultData(data:Partial<IProjectData>):IProjectData{
    const result = _.merge(createProjectDefultData(), data);
    result.triggerActionGroup = mergeTriggerActionGroupToDefultData(result.triggerActionGroup)
    return result   
}
